__turbopack_context__.v({
  "black": "button-module-scss-module__ue55bW__black",
  "button": "button-module-scss-module__ue55bW__button",
  "danger": "button-module-scss-module__ue55bW__danger",
  "dark": "button-module-scss-module__ue55bW__dark",
  "info": "button-module-scss-module__ue55bW__info",
  "light": "button-module-scss-module__ue55bW__light",
  "loader": "button-module-scss-module__ue55bW__loader",
  "outline": "button-module-scss-module__ue55bW__outline",
  "primary": "button-module-scss-module__ue55bW__primary",
  "secondary": "button-module-scss-module__ue55bW__secondary",
  "success": "button-module-scss-module__ue55bW__success",
  "transparent": "button-module-scss-module__ue55bW__transparent",
  "warning": "button-module-scss-module__ue55bW__warning",
});
